import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ServiceDetailPageContainer } from './ServiceDetailPage';
import { FaPaperPlane } from 'react-icons/fa';
import { motion } from 'framer-motion';
import emailjs from '@emailjs/browser';

const ServiceImage = styled.img`
  max-width: 200px; /* Smaller size */
  height: auto;
  border-radius: 0; /* Remove border-radius */
  margin: 0.5rem 0 1rem 2rem; /* Adjusted margin for text wrapping */
  box-shadow: none; /* Remove box-shadow */
  float: right; /* Allow text to wrap around */

  @media (max-width: 768px) {
    float: none;
    margin: 1rem auto;
    max-width: 80%;
    display: block;
  }
`;

const ContactSection = styled.section`
  padding: 4rem 2rem;
  background: linear-gradient(45deg, #00B4DB, #007bff);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 250px;
  color: white;
  position: relative;
  overflow: hidden;
  margin-top: 8rem;
  border-radius: 20px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 30%;
    height: 100%;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.15), transparent);
    transform: skewX(-20deg) translateX(30%);
    transform-origin: top right;
    pointer-events: none;
    z-index: 0;
  }
`;

const ContactContent = styled.div`
  position: relative;
  z-index: 1;
  max-width: 600px;
  width: 100%;
`;

export const ContactTitle = styled.h2`
  color: #fff !important;
  margin-top: 0 !important;
`;

const ContactForm = styled.form`
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;

const ContactInput = styled.input`
  padding: 1rem 1.5rem;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  flex: 1;
  min-width: 200px;
  background: rgba(255, 255, 255, 0.9);
  color: #1f2937;

  &::placeholder {
    color: #6b7280;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
  }
`;

const SubmitButton = styled.button`
  background: #00B4DB;
  color: white;
  border: none;
  padding: 1rem 1.5rem;
  font-size: 1.2rem;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 180, 219, 0.2);

  &:hover {
    background: #007bff;
    transform: scale(1.02);
    box-shadow: 0 4px 12px rgba(0, 180, 219, 0.3);
  }

  svg {
    margin: 0;
  }
`;

function SocialMedia() {
  const [formData, setFormData] = useState({
    name: '',
    phone: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'phone') {
      // Only allow numbers and limit to exactly 11 digits
      const numbersOnly = value.replace(/[^\d]/g, '');
      if (numbersOnly.length <= 11) {
        setFormData({
          ...formData,
          [name]: numbersOnly
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.phone.length !== 11) {
      alert('Telefon numarası 11 haneli olmalıdır.');
      return;
    }

    try {
      const templateParams = {
        name: formData.name,
        phone: formData.phone,
        time: new Date().toLocaleString('tr-TR')
      };

      await emailjs.send(
        'service_771tgg7',
        'template_w676du8',
        templateParams,
        'xjG6_a9zdp6ZU1zHp'
      );

      alert('Başarılı');
      setFormData({ name: '', phone: '' });
    } catch (error) {
      alert('Bir hata oluştu');
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ServiceDetailPageContainer>
      <h1>Sosyal Medya Yönetimi</h1>
      <p>Markanızın sosyal medyadaki varlığını güçlendiriyor, hedef kitlenizle etkileşimi artırıyoruz. Sosyal medya stratejileri, içerik oluşturma, topluluk yönetimi ve reklam yönetimi gibi konularda size özel çözümler sunuyoruz.</p>

      <ServiceImage src="/media/demirer-ajans-4.png" alt="Sosyal Medya Yönetimi Görseli 1" />

      <h2>Neden Sosyal Medya Yönetimi Önemlidir?</h2>
      <p>Sosyal medya, markaların hedef kitleleriyle doğrudan etkileşim kurduğu, marka bilinirliğini artırdığı ve satışları doğrudan etkilediği güçlü bir platformdur. Doğru stratejilerle yönetilen sosyal medya hesapları, müşteri sadakatini artırırken yeni müşteriler kazanmanıza da olanak tanır.</p>

      <ServiceImage src="/media/demirer-ajans-5.png" alt="Sosyal Medya Yönetimi Görseli 2" />

      <h3>Hizmetlerimiz Neleri Kapsar?</h3>
      <ul>
        <li><b>Strateji Geliştirme:</b> Markanızın hedeflerine uygun, özelleştirilmiş sosyal medya stratejileri oluşturma.</li>
        <li><b>İçerik Oluşturma:</b> Görsel ve yazılı olarak etkileyici, ilgi çekici ve paylaşılabilir içerikler üretme (grafikler, videolar, metinler).</li>
        <li><b>Topluluk Yönetimi:</b> Takipçilerle etkileşim kurma, yorumları ve mesajları yanıtlama, marka itibarını yönetme.</li>
        <li><b>Sosyal Medya Reklamcılığı:</b> Hedeflenmiş reklam kampanyaları ile doğru kitleye ulaşma ve dönüşümleri artırma.</li>
        <li><b>Analiz ve Raporlama:</b> Sosyal medya performansını düzenli olarak izleme, raporlama ve stratejileri optimize etme.</li>
        <li><b>Trend Takibi:</b> Sosyal medya trendlerini ve algoritma güncellemelerini yakından takip ederek stratejileri güncel tutma.</li>
      </ul>

      <ServiceImage src="/media/demirer-ajans-6.png" alt="Sosyal Medya Yönetimi Görseli 3" />

      <h2>Markanız İçin Nasıl Bir Sosyal Medya Stratejisi Oluşturuyoruz?</h2>
      <p>Markanızın sektörünü, hedef kitlenizi ve rekabet ortamını derinlemesine analiz ederek size özel bir sosyal medya yol haritası belirliyoruz. Markanızın sesini ve değerlerini sosyal medya platformlarına taşıyarak, hedef kitlenizle anlamlı ve kalıcı bağlar kurmanızı sağlıyoruz.</p>
      <p>Dijitalde güçlü bir varlık göstermek ve sosyal medyanın tüm potansiyelini kullanmak için bize güvenebilirsiniz.</p>

      <h2>Sosyal Medya Yönetimi Hizmetlerimiz</h2>
      <p>Sosyal medya yönetimi hizmetlerimiz, işletmenizin sosyal medya varlığını güçlendirmek için tasarlanmıştır. Uzman ekibimiz, içerik üretimi, topluluk yönetimi ve performans analizi konularında profesyonel çözümler sunar.</p>
      <p>Stratejik planlama ve yaratıcı içeriklerle, markanızın sosyal medyada etkili bir şekilde temsil edilmesini sağlıyoruz. İşletmenizin sosyal medya başarısını artırmak için bize güvenebilirsiniz.</p>

      <ContactSection>
        <ContactContent>
          <ContactTitle>Sizi Arayalım</ContactTitle>
          <ContactForm onSubmit={handleSubmit}>
            <ContactInput 
              type="text" 
              name="name"
              placeholder="Adınız"
              value={formData.name}
              onChange={handleInputChange}
              required 
            />
            <ContactInput 
              type="tel" 
              name="phone"
              placeholder="Telefon Numaranız (11 Haneli)"
              value={formData.phone}
              onChange={handleInputChange}
              pattern="[0-9]*"
              inputMode="numeric"
              maxLength="11"
              minLength="11"
              required 
            />
            <SubmitButton
              type="submit"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaPaperPlane />
            </SubmitButton>
          </ContactForm>
        </ContactContent>
      </ContactSection>
    </ServiceDetailPageContainer>
  );
}

export default SocialMedia; 